$(function () {
  if ($("body").hasClass("single-internal-exh")) {
    setupFilterByTags();
    setupMobileFilterUI();
    setupContactVisibilityObserver();
    iexhLoaded();

    setTimeout(updateFilter, 10);
    $('input[name="iexh__filter"]').on("change", updateFilter);

    adjustHeightsByRowAuto({
      itemSelector: ".c-FxItem",
      objectPrefix: "c-FxOj-",
    });
  }
});

function iexhLoaded() {
  setTimeout(function () {
    $(".iexh__contact").addClass("is-loaded");
  }, 1000);
}

function setupFilterByTags() {
  const $radios = $('.iexh__filter-buttons input[type="radio"]');
  const $blocks = $(".iexh__contents-card");

  $radios.on("change", function () {
    const selected = $(this).val();
    $blocks.each(function () {
      const tags = ($(this).data("tags") || "").split(" ");
      $(this).css("display", selected === "all" || tags.includes(selected) ? "block" : "none");
    });
  });
}

function setupMobileFilterUI() {
  if (window.matchMedia("(max-width: 991px)").matches) {
    const $filterButton = $(".iexh__filter-label");
    const $filter = $(".iexh__filter-container");
    const $filterInner = $(".iexh__filter-container-bg");
    const $filterClose = $(".iexh__filter-container-close");
    const $radioButtons = $(".iexh__filter-buttons input[type='radio']");
    let scrollPosition = 0;

    const disableScroll = () => {
      scrollPosition = $(window).scrollTop();
      $("body").css({
        position: "fixed",
        top: `-${scrollPosition}px`,
        width: "100%",
      });
    };

    const enableScroll = () => {
      $("body").css({ position: "", top: "", width: "" });
      window.scrollTo(0, scrollPosition);
    };

    const closeFilter = () => {
      $filter.hide();
      enableScroll();
    };

    $filterButton.on("click", () => {
      $filter.show();
      disableScroll();
    });

    $filterInner.on("click", closeFilter);
    $filterClose.on("click", closeFilter);
    $radioButtons.on("change", closeFilter);
  }
}

function setupContactVisibilityObserver() {
  const contact = $(".iexh__contact").get(0);
  const bottomLinks = $(".p-bottomLinks").get(0);

  if (!window.IntersectionObserver) return;
  if (!contact || !bottomLinks) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        $(contact).css("opacity", entry.isIntersecting ? "0" : "1");
      });
    },
    {
      root: null,
      threshold: 0.1,
    }
  );

  observer.observe(bottomLinks);
}

function updateFilter() {
  const $selectedRadio = $('input[name="iexh__filter"]:checked');
  const selectedValue = $selectedRadio.val();
  const $label = $selectedRadio.closest("label");
  const labelText = $label.length ? $label.text().trim() : "すべて";

  $(".p-FilterTitle__text span b").text(labelText);
}

function adjustHeightsByRowAuto(options) {
  const { itemSelector, objectPrefix = "c-oj-" } = options;
  let resizeTimeout;

  function resizeHandler() {
    const $allItems = $(itemSelector);
    const $visibleItems = $allItems.filter(function () {
      return $(this).is(":visible");
    });

    if (!$visibleItems.length) return;

    const $firstItem = $visibleItems.eq(0);
    const classes = $firstItem
      .find(`[class*="${objectPrefix}"]`)
      .map(function () {
        return $(this)
          .attr("class")
          .split(" ")
          .filter((cls) => cls.startsWith(objectPrefix));
      })
      .get()
      .flat();

    const selectors = [...new Set(classes)].map((cls) => "." + cls);

    // reset heights
    $visibleItems.each(function () {
      selectors.forEach((selector) => {
        $(this).find(selector).css("height", "");
      });
    });

    const rows = groupItemsByRow($visibleItems);

    rows.forEach((rowItems) => {
      const maxHeights = {};
      selectors.forEach((selector) => {
        maxHeights[selector] = 0;
        rowItems.each(function () {
          const $el = $(this).find(selector);
          if ($el.length) {
            $el.css("height", "");
            maxHeights[selector] = Math.max(maxHeights[selector], $el.outerHeight());
          }
        });
      });

      rowItems.each(function () {
        selectors.forEach((selector) => {
          $(this)
            .find(selector)
            .css("height", maxHeights[selector] + "px");
        });
      });
    });
  }

  function debounceResizeHandler() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(resizeHandler, 100);
  }

  function groupItemsByRow($items) {
    const rows = [];
    let currentTop = null;
    let currentRow = $();

    $items.each(function () {
      const $item = $(this);
      const top = $item.offset().top;

      if (currentTop === null || top === currentTop) {
        currentRow = currentRow.add($item);
        currentTop = top;
      } else {
        rows.push(currentRow);
        currentRow = $item;
        currentTop = top;
      }
    });

    if (currentRow.length) rows.push(currentRow);
    return rows;
  }

  $(window).on("resize", debounceResizeHandler);
  $(window).on("load", debounceResizeHandler);
}
